<script>
  export let rating = 0;

  const rates = [5, 4, 3, 2, 1];

  const starIcon = `<svg viewBox="0 0 24 24" fill="currentColor" class="icon icon-sm">
    <path d="M12 1.7 9.5 9.2H1.6L8 13.9l-2.4 7.6 6.4-4.7 6.4 4.7-2.4-7.6 6.4-4.7h-7.9L12 1.7z" />
  </svg>`;
</script>

<fieldset class="rating rating-label">
  {#each rates as rate}
    <input
      type="radio"
      id={`star${rate}b`}
      name="ratingB"
      value={rate}
      bind:group={rating}
      data-element="feedback-rate-{rate}"
    />
    <label class="full" for={`star${rate}b`}>
      {@html starIcon}
      <!-- <svg class="icon icon-sm" aria-hidden="true">
        <use href="/svg/sprites.svg#it-star-full"></use>
      </svg> -->
    </label>
  {/each}
</fieldset>
